export default {
  placeholder: {
    pseudo: "::placeholder",
  },
  "placeholder-c": {
    pseudo: "::placeholder",
  },
};
